import { useAppSelector } from 'store/store';

import { selectCurrentArticleIndex } from '../../../store/consigmentSwitcher';
import { selectShipment } from '../../../store/shipment/shipment.selectors';
/**
 * Custom hook for fetching shipment based on tracking id from the URL params
 * @returns a single shipment for Details page display
 */
export const useShipment = () => {
  return useAppSelector(selectShipment);
};

/**
 * Custom hook for getting articles info within a shipment
 * @returns an array of articles within a shipment
 */
export const useArticles = () => {
  const currentShipment = useShipment();
  return currentShipment?.articles ?? [];
};

/**
 * Custom hook for getting the current displaying article within the article array list based on trackingId
 * This is mainly used for multi-article consignments
 */
export const useCurrentArticle = () => {
  const articles = useArticles();
  const selectedArticleIndex = useAppSelector(selectCurrentArticleIndex);
  return articles[selectedArticleIndex] ?? null;
};

/**
 * Custom hook for getting the first article within a shipment
 */
export const useFirstArticle = () => {
  const articles = useArticles();
  return articles?.[0] ?? null;
};
